import { createReducer, on } from '@ngrx/store';
import {
  loadFloors,
  loadFloorsSuccess,
  loadFloorsFailure,
  addFloor,
  addFloorSuccess,
  addFloorFailure,
  deleteFloor,
  deleteFloorSuccess,
  deleteFloorFailure,
  clearFloors,
} from './floors.actions';
import { Floor } from '../../interfaces/state/entities/floor.interface';
import { FloorsState } from '../../interfaces/state/reducers/floors-state.interface';

export const initialState: FloorsState = {
  floors: [],
  loading: false,
  error: null,
};

export const floorsReducer = createReducer(
  initialState,
  on(loadFloors, (state) => ({ ...state, loading: true, error: null })),
  on(loadFloorsSuccess, (state, { floors }) => ({
    ...state,
    floors,
    loading: false,
  })),
  on(loadFloorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addFloor, (state) => ({ ...state, loading: true, error: null })),
  on(addFloorSuccess, (state, { floor }) => ({
    ...state,
    floors: [...state.floors, floor],
    loading: false,
  })),
  on(addFloorFailure, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(deleteFloor, (state) => ({ ...state, loading: true, error: null })),
  on(deleteFloorSuccess, (state, { id }) => ({
    ...state,
    floors: state.floors.filter((f) => f.id !== id),
    loading: false,
  })),
  on(deleteFloorFailure, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(clearFloors, () => initialState)
);
